/* eslint-disable */
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import moment from 'moment';
import { Candidate, EngagedCandidate, RecruiterInterviewReview } from '../firebase/firestore/documents/candidate';
import { ExcludedAccount } from '../firebase/firestore/documents/seeker';

export const isCandidatePage = (): boolean => {
  const location = window.location.href;
  return location.includes('/candidate/');
};
export const isCandidatesPage = (): boolean => {
  const location = window.location.href;
  return location.includes('/candidates/');
};

export const isCandidateOnDashboard = (): boolean => {
  const location = window.location.href;
  return location.includes('/dashboard');
};

export const isPositionCandidatesPage = (): boolean => {
  const location = window.location.href;
  return location.includes('/positionCandidates/');
};

export const isCandidateSearchPage = (): boolean => {
  const location = window.location.href;
  return location.includes('/candidateSearch');
};

export const isNewSeekerListPage = (): boolean => {
  const location = window.location.href;
  const pages = ['/newMessaging', '/newCandidates'];
  return pages.some((page) => location.includes(page));
};

const getMaxFromList = (list: Array<Date | undefined>) => {
  const latestDate = list.filter((d) => d !== undefined).map((d) => moment(d));
  return moment.max(latestDate);
};

export const DEFAULT_FILTER_CANDIDATE_BY_DAYS = 90;

export const getLatestDateForSorting = (candidate: EngagedCandidate) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (candidate?.lastMessageAt?.fromSeeker || candidate?.forSorting) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return getMaxFromList([candidate?.lastMessageAt?.fromSeeker, candidate?.forSorting]);
  }
  return moment().subtract(1, 'year').toDate();
};

export const isCandidateRated = (candidate?: Candidate, email?: string): boolean => {
  // istanbul ignore if
  if (!candidate?.recruiterInterviewReviews || candidate.recruiterInterviewReviews.length === 0) return false;

  const targetEmail = email?.trim().toLowerCase() ?? candidate.email?.trim().toLowerCase();
  /* istanbul ignore if */ if (!targetEmail) return false;

  return candidate.recruiterInterviewReviews.some((review) => {
    /* istanbul ignore if */ if (!isObject(review)) return false;

    const { email: reviewEmailRaw, rating: ratingRaw } = review as RecruiterInterviewReview;
    if (!isString(reviewEmailRaw) || isEmpty(reviewEmailRaw.trim())) return false;

    const emails = reviewEmailRaw.split(',').map((e) => e.trim().toLowerCase());
    if (!emails.includes(targetEmail)) return false;

    const rating = isString(ratingRaw) ? Number(ratingRaw) : /* istanbul ignore next */ ratingRaw;
    return isNumber(rating);
  });
};

export const getCandidateRatingAndReview = (
  candidate: Candidate,
  email: string,
): { rating: number; review: string } | undefined => {
  // istanbul ignore if
  if (!candidate?.recruiterInterviewReviews || candidate.recruiterInterviewReviews.length === 0) return undefined;

  const targetEmail = email?.trim().toLowerCase() ?? /* istanbul ignore next */ candidate.email?.trim().toLowerCase();
  // istanbul ignore if
  if (!targetEmail) return undefined;

  const foundReview = candidate.recruiterInterviewReviews.find((review) => {
    if (!isObject(review)) return false;

    const { email: reviewEmailRaw, rating: ratingRaw, review: reviewText } = review as RecruiterInterviewReview;
    if (!isString(reviewEmailRaw) || isEmpty(reviewEmailRaw.trim())) return false;

    const emails = reviewEmailRaw.split(',').map((e) => e.trim().toLowerCase());
    if (!emails.includes(targetEmail)) return false;

    const rating = isString(ratingRaw) ? Number(ratingRaw) : /* istanbul ignore next */ ratingRaw;
    // istanbul ignore if
    if (!isNumber(rating)) return false;

    return isString(reviewText) && !isEmpty(reviewText.trim());
  });
  // istanbul ignore if
  if (!foundReview) return undefined;

  return {
    rating: isString(foundReview.rating) ? Number(foundReview.rating) : /* istanbul ignore next */ foundReview.rating,
    review: foundReview.review,
  };
};

export const getInterviewTime = (interviewDate: Date | undefined): string => {
  const interviewStartTime = moment(interviewDate);
  return `${moment(interviewStartTime).format('h:mm A')}`;
};

export const isBlacklistedBySeeker = ({
  excludedAccounts,
  accountId,
}: {
  excludedAccounts: ExcludedAccount[] | undefined;
  accountId: string;
}): boolean => {
  if (!accountId || !Array.isArray(excludedAccounts)) return false;

  const blacklistedBySeeker = excludedAccounts.some(
    (acc: ExcludedAccount) => acc.account && acc.account === accountId && acc.type === 'blacklisted' && acc.isFromSeeker,
  );

  return blacklistedBySeeker;
};
